import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

import HomeScreen from "./Home";
import DNSTool from "./DNS";
import SPFTool from "./SPF";
import RBLTool from "./RBL";
import NetworkTool from "./Network";

class Main extends Component {
  render() {
    return (
      <main role="main" className="container">
        <Switch>
          <Route exact path="/" component={HomeScreen} />>
          <Route exact path="/dns" component={DNSTool} />
          <Route exact path="/dns/:hostname/:record" component={DNSTool} />
          <Route exact path="/spf" component={SPFTool} />
          <Route exact path="/spf/:hostname" component={SPFTool} />
          <Route exact path="/rbl" component={RBLTool} />
          <Route exact path="/rbl/:ipaddress" component={RBLTool} />
          <Route exact path="/network" component={NetworkTool} />
          <Route exact path="/network/:ipaddress" component={NetworkTool} />
          <Route exact path="/network/:ipaddress/:prefix" component={NetworkTool} />
        </Switch>
      </main>
    );
  }
}

export default Main;




// WEBPACK FOOTER //
// ./src/Main.js